/* error serializer function for createAsyncThunk */
export const serializeError = (error: unknown) => {
  if (error instanceof Error) {
    return error
  }

  return new Error(`Unexpected error: ${error}`)
}
